const state = {
    bankStatement: [],
    loading: false
};

export default state;